import { ArrowUpIcon, ArrowDownIcon } from "@heroicons/react/24/solid";
import { t } from "i18next";

interface PartTableHeaderProps {
  sortField: string;
  sortDirection: "asc" | "desc";
  onSort: (field: string) => void;
}

/**
 * En-tête du tableau des parts avec gestion du tri
 */
export default function PartTableHeader({
  sortField,
  sortDirection,
  onSort
}: PartTableHeaderProps) {
  return (
    <thead className="bg-gray-50">
      <tr className="border-b border-gray-200">
        <th
          className="w-[15%] cursor-pointer overflow-hidden p-2 text-left select-none"
          onClick={() => onSort("label")}
        >
          <div className="flex items-center gap-2 text-xs font-normal text-blue-gray-800 opacity-70 uppercase tracking-wider">
            {t("workorder:parts:title")}
            {sortField === "label" &&
              (sortDirection === "asc" ? (
                <ArrowUpIcon className="h-3 w-3" />
              ) : (
                <ArrowDownIcon className="h-3 w-3" />
              ))}
          </div>
        </th>
        <th
          className="w-[15%] cursor-pointer overflow-hidden p-2 text-left select-none"
          onClick={() => onSort("reference")}
        >
          <div className="flex items-center gap-2 text-xs font-normal text-blue-gray-800 opacity-70 uppercase tracking-wider">
            {t("workorder:parts:reference")}
            {sortField === "reference" &&
              (sortDirection === "asc" ? (
                <ArrowUpIcon className="h-3 w-3" />
              ) : (
                <ArrowDownIcon className="h-3 w-3" />
              ))}
          </div>
        </th>
        <th
          className="w-[5%] cursor-pointer overflow-hidden p-2 text-left select-none"
          onClick={() => onSort("quantity")}
        >
          <div className="flex min-w-0 items-center gap-1 text-xs font-normal text-blue-gray-800 opacity-70 uppercase tracking-wider">
            <span className="truncate" title={t("workorder:parts:quantity")}>
              {t("workorder:parts:quantity")}
            </span>
            {sortField === "quantity" &&
              (sortDirection === "asc" ? (
                <ArrowUpIcon className="h-3 w-3" />
              ) : (
                <ArrowDownIcon className="h-3 w-3" />
              ))}
          </div>
        </th>
        <th
          className="w-[10%] cursor-pointer overflow-hidden p-2 text-left select-none"
          onClick={() => onSort("purchasePrice")}
        >
          <div className="flex items-center gap-2 text-xs font-normal text-blue-gray-800 opacity-70 uppercase tracking-wider">
            {t("workorder:parts:costPrice")}
            {sortField === "purchasePrice" &&
              (sortDirection === "asc" ? (
                <ArrowUpIcon className="h-3 w-3" />
              ) : (
                <ArrowDownIcon className="h-3 w-3" />
              ))}
          </div>
        </th>
        <th
          className="w-[10%] cursor-pointer overflow-hidden p-2 text-left select-none"
          onClick={() => onSort("price")}
        >
          <div className="flex items-center gap-2 text-xs font-normal text-blue-gray-800 opacity-70 uppercase tracking-wider">
            {t("workorder:parts:unitPrice")}
            {sortField === "price" &&
              (sortDirection === "asc" ? (
                <ArrowUpIcon className="h-3 w-3" />
              ) : (
                <ArrowDownIcon className="h-3 w-3" />
              ))}
          </div>
        </th>
        <th
          className="w-[10%] cursor-pointer overflow-hidden p-2 text-left select-none"
          onClick={() => onSort("total")}
        >
          <div className="flex items-center gap-2 text-xs font-normal text-blue-gray-800 opacity-70 uppercase tracking-wider">
            {t("workorder:parts:totalPrice")}
            {sortField === "total" &&
              (sortDirection === "asc" ? (
                <ArrowUpIcon className="h-3 w-3" />
              ) : (
                <ArrowDownIcon className="h-3 w-3" />
              ))}
          </div>
        </th>
        <th className="w-[5%] overflow-hidden p-2 text-left select-none">
          <div className="truncate text-center text-xs font-normal uppercase tracking-wider text-blue-gray-800 opacity-70" title={t("workorder:parts:desk")}>
            {t("workorder:parts:desk")}
          </div>
        </th>
        <th className="w-[10%] overflow-hidden p-2 text-left select-none">
          <div className="truncate text-xs font-normal uppercase tracking-wider text-blue-gray-800 opacity-70" title={t("workorder:parts:purchaseOrder:documentReference")}>
            {t("workorder:parts:purchaseOrder:documentReference")}
          </div>
        </th>
        <th className="w-[10%] overflow-hidden p-2 text-left select-none">
          <div className="truncate text-xs font-normal uppercase tracking-wider text-blue-gray-800 opacity-70" title={t("workorder:parts:attachments:title")}>
            {t("workorder:parts:attachments:title")}
          </div>
        </th>
        <th className="w-[10%] overflow-hidden p-2 text-left select-none">
          <div className="text-xs font-normal text-blue-gray-800 opacity-70 uppercase tracking-wider text-center">
            {t("workorder:parts:actions")}
          </div>
        </th>
      </tr>
    </thead>
  );
} 